import type {FC} from 'react';

type PropsType = {
  children: number;
  isCoach?: boolean;
};

import * as S from './styles';

export const MainMenuBadge: FC<PropsType> = ({
  children,
  isCoach,
}: PropsType) => {
  return (
    <S.Container coach={isCoach}>
      <S.Label>{children}</S.Label>
    </S.Container>
  );
};
